import React, { useState } from 'react';
import { DT_ZONES } from './dtZones';
import { useT } from '../i18n/LanguageContext';
import './EvidenceTray.css';

// Screen-fixed (not canvas-fixed) collapsible tray listing evidence chips
// grouped by phase — used in mappatura mode, where there are no phase
// columns to anchor a per-column chip band to (see ZoneLayer.js's
// tradizionale-only chip band, added in 2026-08-17-evidence-chip-redesign).
export default function EvidenceTray({ evidenceChips }) {
  const [open, setOpen] = useState(true);
  const t = useT();
  const groups = DT_ZONES
    .map((z) => ({ zone: z, chips: evidenceChips[z.key] || [] }))
    .filter((g) => g.chips.length > 0);

  if (groups.length === 0) return null;

  return (
    <div className={`evidence-tray${open ? '' : ' is-collapsed'}`}>
      <div className="evidence-tray__header" onClick={() => setOpen((v) => !v)}>
        <span className="evidence-tray__title">{t('canvas.evidenceTray.title')}</span>
        <span className="evidence-tray__caret">{open ? '▾' : '▸'}</span>
      </div>
      {open && (
        <div className="evidence-tray__body">
          {groups.map((g) => (
            <div key={g.zone.key} className="evidence-tray__group" style={{ '--zone-color': g.zone.color }}>
              <span className="evidence-tray__group-label">{g.zone.icon} {t(`canvas.zones.${g.zone.key}`)}</span>
              <div className="evidence-tray__chips">
                {g.chips.map((text, i) => (
                  <span key={i} className="evidence-chip">{text}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
